export default __webpack_public_path__ + "static/media/p.340173c3.png";